// ---------------------------------------------------------------
// IMPORTS
// ---------------------------------------------------------------
import { log, errorlog } from '../logger/logger';

// json
import Config from '../../config.json';

// markup
import NodeContentMarkup from 'raw-loader!./markup.html';

// ---------------------------------------------------------------
// DEFAULTS
// ---------------------------------------------------------------
let store = {};
let settings = {};
let edge = {};
let i18n = {};
let i18nJson = {};
let fonts = {};
let design = {};

let usedIconPath = '';

let nodeId = 0;
let isDragging = false;
let draggedNode = {};
let isMouseDown = false;

let isDrawingEdge = false;
let drawEdgeFromNode = {};
let drawEdgeToNode = {};

let oldMaxVisibilityLevel = 1;
let currentVisibilityLevel = 1;

const allCurrentDomNodes = {};

// ---------------------------------------------------------------
// CLASS
// ---------------------------------------------------------------
export class Node {

    constructor() {}

    init(globalStore, globalSettings, globalEdge, globalI18n, globalFonts, globalDesign) {
        log('node init');

        // global objects
        store = globalStore;
        settings = globalSettings;
        edge = globalEdge;
        i18n = globalI18n;
        i18nJson = i18n.getCurrentJson();
        fonts = globalFonts;
        design = globalDesign;

        // needed node stuff
        setEventListener();
    }

    add(mouseX, mouseY, currentMapScale) {
        add(mouseX, mouseY, currentMapScale);
    }

    remove(getSelectedElement, getElementId) {
        remove(getSelectedElement, getElementId);
    }

    copy(currentNodeId, type) {
        copy(currentNodeId, type);
    }

    removeClassSelected() {
        removeClassSelected();
    }

    removeClassDrawSelected() {
        removeClassDrawSelected();
    }

    clearDrawingStates() {
        clearDrawingStates();
    }
}

// ---------------------------------------------------------------
// PRIVATE FUNCTIONS
// ---------------------------------------------------------------

// EVENTLISTENER
// ---------------------------------------------------------------
function setEventListener() {
    let mouseX, mouseY;
    const app = $('app');
    let map = $('map');
    let currentMapScale = 1;

    app.on('mousedown touchstart', 'node', (event) => {
        event.stopPropagation();
        // prevent action if node edited by another user
        const currentNode = $(event.currentTarget);
        if (currentNode.length && currentNode.hasClass('edited')) return;
        isMouseDown = true;

        map = $('map');
        currentMapScale = map.css('transform').split('(')[1];
        currentMapScale = currentMapScale.split(')')[0];
        currentMapScale = currentMapScale.split(',');
        currentMapScale = parseFloat(currentMapScale[0]);
        
        draggedNode = currentNode;
        edge.prepareAttachedEdgesToUpdatePositions(currentNode);
        edge.removeClassSelected();

        removeClassSelected();
        removeClassDrawSelected();
    });

    app.on('click', 'node', (event) => {
        event.stopPropagation();
        const currentNode = $(event.currentTarget);
        if(currentNode.hasClass('selected')) return;

        if(isDrawingEdge === false) {
            // select node
            currentNode.addClass('selected');
            clearDrawingStates();

            // show settings and trigger event to open settings content
            settings.show();
            currentNode.removeClass('draw-selected');
            $(document).trigger('nodeClickedEvent', [currentNode]);
        }

        if(isDrawingEdge === true && drawEdgeFromNode.data('id') !== currentNode.data('id')) {
            drawEdgeToNode = currentNode;

            // create edge edge between the two nodes
            const fromNodeId = drawEdgeFromNode.data('id');
            const toNodeId = drawEdgeToNode.data('id');
            edge.add(fromNodeId, toNodeId);
            edge.removeClassDragging();
            // trigger to emit event to create edge for other users online
            $(document).trigger('edgeCreatedEvent', [{fromNodeId, toNodeId}])

            // deselect nodes
            drawEdgeFromNode.removeClass('draw-selected');
            clearDrawingStates();
        }
    });

    app.on('dblclick', 'node', (event) => {
        event.stopPropagation();
        const currentNode = $(event.currentTarget);

        if(isDrawingEdge === false) {
            currentNode.addClass('draw-selected');
            settings.hide();

            // node from must be active
            isDrawingEdge = true;
            drawEdgeFromNode = currentNode;
        }
    });

    app.on('mousemove touchmove', 'node', (event) => {
        event.preventDefault();
        event.stopPropagation();

        // regular move node
        if(isMouseDown === true && isDragging === false) {
            draggedNode.addClass('dragging');
        }

        if(isMouseDown === true) {
            log('mousemove at node:')
            log('pageX:'+ event.pageX)
            log('mapOffset LEFT: '+ map.offset().left)
            log('pageY:' + event.pageY);
            log('mapOffset TOP: '+ map.offset().top)
            mouseX = (event.pageX || event.clientX) - map.offset().left;
            mouseY = (event.pageY || event.clientY) - map.offset().top;
            isDragging = true;

            // rerender node position
            updateNodePosition(draggedNode, mouseX, mouseY, currentMapScale);

            // rerender attached edges positions
            // --> needs more computing power
            edge.updateAttachedEdgesPositionsFromNode();
            edge.addClassDragging();

            settings.hide();
        }
    });

    app.on('mouseup touchend', 'node', (event) => {
        event.stopPropagation();
        isMouseDown = false;
        const currentNode = $(event.currentTarget),
            currnetNodeId = currentNode.data('id');

        if(isDragging === true) {
            currentNode.removeClass('dragging');
            isDragging = false;
            draggedNode = {};
            $(document).trigger('nodeDraggingOff', [currnetNodeId])
        }
    });

    // triggered from modules/settings/settings.js
    $(document).on('updateNodeDataEvent', (event, currentNodeId) => {
        const currentNode = $(`node[data-id=${currentNodeId}]`);
        const currentElement = $('.selected');
        log('UPDATE node data event');
        log(currentNodeId);
        if(currentElement && (parseInt(currentElement.data('id')) === parseInt(currentNodeId))){
            updateNodeDataToDom(currentNode, currentNodeId, 'regular');
        } else {
            updateNodeDataToDom(currentNode, currentNodeId, 'init');
        }
        
        edge.updateAttachedEdgesVisibilityFromNode();
        edge.updateAttachedEdgesPositionsFromNode();
    });

    // triggered from modules/xhr/xhr.js
    $(document).on('initMapDataEvent', () => {
        oldMaxVisibilityLevel = store.get().map.visibilityLevels;
        drawInitNodes();
    });

    // triggered from modules/settings/settings.js
    $(document).on('updateMapDataEvent', () => {
        updateAllNodesMaxVisibilityLevel();
        updateAllNodesVisibilityLevel();
    });

    // triggered from modules/map/map.js
    $(document).on('currentVisibilityLevel', (event, visibilityLevel) => {
        currentVisibilityLevel = visibilityLevel;
    });
    
    // triggered from modules/map/map.js
    $(document).on('syncEdgeCreated', (event, {fromNodeId, toNodeId}) => {
        log('');
        log('Adding edge connected: ');
        log({fromNodeId, toNodeId});
        log('-------------------------');
        edge.add(fromNodeId, toNodeId);
    })
    
    // triggered from modules/map/map.js
    // emitted event to sync data from popup form
    $(document).on('syncPopupData', (event, diff) => {
        const nodeId = Object.keys(diff)[0],
          nodeDOM = $(`node[data-id=${nodeId}]`),
          editedNodeData = diff[nodeId];
        let currentNodeData = null;
        let currentEditedNode = $('node.selected');
        Object.entries(store.get().nodes).forEach(([id, node]) => {
            if (nodeId === id) {
                currentNodeData = JSON.parse(JSON.stringify(store.get().nodes[id]));
            }
        })
        currentNodeData.content.title = editedNodeData.title;
        currentNodeData.content.article = editedNodeData.article;
        currentNodeData.content.links = editedNodeData.links;
        currentNodeData.content.content = editedNodeData.content;
        
        updateNodeToStore(nodeId, currentNodeData);
        if (currentEditedNode.length && (parseInt(currentEditedNode.data('id')) !== parseInt(nodeId))) {
            // update node with selected classname
            log('Update TINY FIELDS NODE ID is DIFFERENT');
            updateNodeDataToDom(nodeDOM, nodeId, 'regular');
        } else if (currentEditedNode.length && (parseInt(currentEditedNode.data('id')) === parseInt(nodeId))) {
            log('Update TINY FIELDS NODE ID is THE SAME');
            // update node without selected classname adding
            updateNodeDataToDom(nodeDOM, nodeId, 'regular');
            if (tinyMCE) {
                log('Update TINY FIELDS FROM POPUP FORM');
                $('#title').val(editedNodeData.title);
                tinyMCE.editors['content'].setContent(editedNodeData.content)
                tinyMCE.editors['links'].setContent(editedNodeData.links)
                tinyMCE.editors['article'].setContent(editedNodeData.article)
            }
        } else {
            // update node without selected classname adding
            log('Update TINY FIELDS NODE ID is something else');;
            updateNodeDataToDom(nodeDOM, nodeId, 'init');
        }
    });
    
    // triggered from modules/map/map.js
    $(document).on('syncNodePosition', (event, diff) => {
        // dragged node is the current edited node
        const nodeId = Object.keys(diff)[0],
              nodeData = diff[nodeId],
              nodeDOM = $(`node[data-id=${nodeId}]`);
        const currentElement = $('.selected');
        const newX = (nodeData.position.x + nodeDOM.width() / 2) * currentMapScale;
        const newY = (nodeData.position.y + nodeDOM.height() / 2) * currentMapScale;
        // break if the same user || solve currentMapScale for edited user
        
        // rerender node position
        updateNodePosition(nodeDOM, newX, newY, currentMapScale);
        // update sizes, content etc.
       
        if (currentElement && (parseInt(currentElement.data('id')) === parseInt(nodeId))){
            log('selected class added here:')
            log(currentElement);
            log(parseInt(currentElement.data('id')));
            log(nodeData)
            log(tinyMCE);
            log()
            
            /*if(tinyMCE && tinyMCE.editors.length) {
                log('Tiny will be changed here');
                // update design section fields;
                $('#objectTemplate').val(nodeData.design.objectTemplate);
                if (nodeData.content.icon) {
                    $('#icon').val(nodeData.content.icon);
                }
                $('#titlePosition').val(nodeData.design.titlePosition);
                $('#width').val(nodeData.measurement.width);
                $('#bgColor').val(nodeData.design.bgColor);
                $('#fontFamily').val(nodeData.design.fontFamily);
                $('#fontSize').val(nodeData.design.fontSize);
                $('#fontColor').val(nodeData.design.fontColor);
                $('#borderStyle').val(nodeData.design.borderStyle);
                $('#borderWidth').val(nodeData.design.borderWidth);
                $('#borderColor').val(nodeData.design.borderColor);
                
                // update content section fields;
                $('#title').val(nodeData.content.title);
                $('#nodeLinkTo').val(nodeData.content.nodeLinkTo);
                tinyMCE.editors['content'].setContent(nodeData.content.content)
                tinyMCE.editors['links'].setContent(nodeData.content.links)
                tinyMCE.editors['article'].setContent(nodeData.content.article)
                $('#abstract').val(nodeData.content.abstract);
                $('#nodeSearchTerms').val(nodeData.content.nodeSearchTerms);
                
                // update visibility section fields;
                $('#minLevel').val(nodeData.visibility.minLevel);
                $('#maxLevel').val(nodeData.visibility.maxLevel);
    
                // update navigation section fields;
                if (nodeData.visibility.previousId) {
                    $('#previousId').val(nodeData.visibility.previousId);
                }
                if (nodeData.visibility.nextId) {
                    $('#nextId').val(nodeData.visibility.nextId);
                }
            }*/
            // update store -> nodes accordingly
            updateNodeToStore(nodeId, nodeData);
            updateNodeDataToDom(currentElement, parseInt(currentElement.data('id')), 'regular');
            settings.putNodeDataToSettings(nodeId);
            // $(document).trigger('nodeDataTinyUpdate', [diff])
            
        } else {
            // update store -> nodes accordingly
            updateNodeToStore(nodeId, nodeData);
            updateNodeDataToDom(nodeDOM, nodeId, 'init');
        }
        
        edge.prepareAttachedEdgesToUpdatePositions(nodeDOM);
        // rerender attached edges positions
        // --> needs more computing power
        edge.updateAttachedEdgesPositionsFromNode();
    });
    
    /*$(document).on('syncCreatedNode', (diff)=> {
        const userId = Object.keys(diff.create)[0];
        const newNode = diff.create[userId];
        addNodeToStore(newNode.newX, newNode.newY, newNode.newNodeId);
        addNodeToDom(newNode.newX, newNode.newY, newNode.newNodeId);
    });*/

    // triggered from modules/settings/settings.js
    $(document).on('updateMapFontsNodeContentEvent', () => {
        // update all nodes to dom and to store
        updateAllNodesFont();
    });
}

// INIT NODES
// ---------------------------------------------------------------
function drawInitNodes() {
    Object.entries(store.get().nodes).forEach(([id, node]) => {
        // add all nodes to dom
        addNodeToDom(node.position.x, node.position.y, id);

        // select new added node and update styles
        const currentNode = $(`node[data-id=${id}]`);
        updateNodeDataToDom(currentNode, id, 'init');

        // set nodeId to last max node id
        if(id >= nodeId) {
            nodeId = parseInt(id) + 1;
        }
    });
}

// ADD NODE
// ---------------------------------------------------------------
function add(mouseX, mouseY, currentMapScale) {
    // center default node
    const newX = mouseX / currentMapScale - design.nodeDefaults.width / 2;
    const newY = mouseY / currentMapScale - design.nodeDefaults.height / 2;
    const $node = $('node');
    const nodesExist = !!$node.length;
    const newNodeId = nodesExist ? parseInt($node.eq($node.length - 1).data('id')) + 1 : 0;
    nodeId = newNodeId;
    log(newNodeId);
    settings.hide();
    removeClassSelected();
    log('add to store:');
    addNodeToStore(newX, newY, newNodeId);
    log('after added to store:');
    addNodeToDom(newX, newY, newNodeId);
}

function addNodeToDom(newX, newY, newNodeId) {
    const translatedNodeContentMarkup = NodeContentMarkup.replace('[i18nNodeNewContent]', i18nJson.node.new.content);
    const fontFamily = design.forNode(newNodeId, 'fontFamily');
    // hide-on-level-X
    const hideNodeList = getHideNodeList(newNodeId);

    // get node z-index > it's important for level control function
    // level 1 = highest z-index, level X = lowest z-index
    const nodeZIndex = getNodeZIndex(newNodeId);

    let newNode = $(`<node data-id="${newNodeId}" style="transform: translate(${newX}px, ${newY}px); font-family: ${fontFamily}; z-index: ${nodeZIndex};" class="${hideNodeList}">${translatedNodeContentMarkup}</node>`)
    const appendedNode = $('map').append(newNode);

    updateNodeDataToDom(newNode, newNodeId, 'init');

    // dom object list of all current nodes
    const lastAppendedNode = appendedNode.children('node:last-child');
    allCurrentDomNodes[newNodeId] = lastAppendedNode;
}

function addNodeToStore(newX, newY, newNodeId) {
    store.get().nodes.set({
        [newNodeId]: {
            measurement: {
                width: null,
                height: null,
                radius: 50
            },
            position: {
                x: newX,
                y: newY
            },
            visibility: {
                minLevel: currentVisibilityLevel,
                maxLevel: store.get().map.visibilityLevels
            },
            design: {
                fontFamily: null,
                fontSize: null,
                fontColor: null,
                bgColor: null,
                borderStyle: null,
                borderWidth: null,
                borderColor: null,
                getOwnPropertyNames: '0',
                popupType: 'popup-panel',
                titlePosition: null,
                iconOpacity: 100,
            },
            content: {
                icon: null,
                title: i18nJson.node.new.content,
                shortContent: '',
                nodeLinkTo: '',
                content: '',
                article: '',
                links: ''
            },
            navigation: {
                previousId: -1,
                nextId: -1
            }
        }
    });

    // update map level control
    $(document).trigger('updateMapLevelControlEvent', ['node-added', newNodeId]);

    log('--- node.js ---');
    log('added new node to store');
    log(store.get());
    log('---------------');
}

// REMOVE NODE
// ---------------------------------------------------------------
function remove(getSelectedElement, getElementId) {
    // prevent remove if node edited
    if(getSelectedElement.hasClass('edited')) return;
    settings.hide();

    edge.removeAllConnectedEdgesFromSelectedNode(getElementId);
    removeNodeFromDom(getSelectedElement);
    removeNodeFromStore(getElementId);
}

function removeNodeFromDom(getSelectedElement) {
    getSelectedElement.remove();

    const removedNodeId = getSelectedElement.data('id');
    delete allCurrentDomNodes[removedNodeId];
}

function removeNodeFromStore(getElementId) {
    store.get().nodes.remove('' + getElementId);

    // update map level control
    $(document).trigger('updateMapLevelControlEvent', ['node-removed', getElementId]);

    log('--- node.js ---');
    log('removed node from store');
    log(store.get());
    log('---------------');
}

// UPDATE NODE
// ---------------------------------------------------------------
function updateNodePosition(currentNode, mouseX, mouseY, currentMapScale) {
    const nodeId = currentNode.data('id');
    const newX = (mouseX - (currentNode.width() * currentMapScale) / 2) / currentMapScale;
    const newY = (mouseY - (currentNode.height() * currentMapScale) / 2) / currentMapScale;

    updateNodeFromDom(currentNode, newX, newY);
    updateNodeFromStore(newX, newY, nodeId);
}

function updateNodeFromDom(currentNode, newX, newY) {
    currentNode.css({
        'transform' : `translate(${newX}px, ${newY}px)`
    });
}

function updateNodeToStore(nodeId, nodeUpdated) {
    store.get().nodes.set({
        [nodeId]: nodeUpdated
    })
}

function updateNodeFromStore(newX, newY, nodeId) {
    // update node store
    store.get().nodes[nodeId].set({
        position: {
            x: newX,
            y: newY
        }
    });

    log('--- node.js ---');
    log('update node from store');
    log(store.get().nodes[nodeId]);
    log('---------------');
}

function updateNodeDataToDom(currentNode, currentNodeId, type = 'regular') { // type = init or regular
    log('updateNodeDataToDom ' + currentNodeId);
    let icon = '';
    let iconUrl = design.forNode(currentNodeId, 'icon') || '';

    // get node z-index > it's important for level control function
    // level 1 = highest z-index, level X = lowest z-index
    const nodeZIndex = getNodeZIndex(currentNodeId);

    // update content
    currentNode.find('.title').html(store.get().nodes[currentNodeId].content.title);
    currentNode.find('.short-content').html(store.get().nodes[currentNodeId].content.shortContent);

    // check if internal or external icon should be shown
    // external: path contains /, e.g. foobar.de/images/foo.png
    if(iconUrl.indexOf('/') > -1) {
        icon = `<custom-icon style="background-image: url(${iconUrl})"></custom-icon>`;
        currentNode.find('.icon-wrapper').html(icon);
        currentNode.find('.icon-wrapper').addClass('active');

    // internal: use defined iconPath
    } else if(iconUrl.length > 0) {
        // check if development or production
        if(isDevelopment() === false) {
            usedIconPath = Config.production.iconPath;
        } else {
            usedIconPath = Config.development.iconPath;
        }

        icon = `<custom-icon style="background-image: url(${usedIconPath}${iconUrl})"></custom-icon>`;
        currentNode.find('.icon-wrapper').html(icon);
        currentNode.find('.icon-wrapper').addClass('active');

    // empty: clear icon wrapper
    } else {
        currentNode.find('.icon-wrapper').html('');
        currentNode.find('.icon-wrapper').removeClass('active');
    }

    let iconOpacity = (design.forNode(currentNodeId, 'iconOpacity') || 100) / 100.0;
    iconOpacity = Math.max(0, iconOpacity);
    iconOpacity = Math.min(1, iconOpacity);
    currentNode.find('.icon-wrapper').css({'opacity': iconOpacity});

    // update styles
    currentNode.css({
        'background': design.forNode(currentNodeId, 'bgColor'),
        'font-family': design.forNode(currentNodeId, 'fontFamily'),
        'font-size': `${design.forNode(currentNodeId, 'fontSize')}px`,
        'color': design.forNode(currentNodeId, 'fontColor'),
        'border-style': design.forNode(currentNodeId, 'borderStyle'),
        'border-color': design.forNode(currentNodeId, 'borderColor'),
        'border-width': design.forNode(currentNodeId, 'borderWidth'),
        'border-radius': `${store.get().nodes[currentNodeId].measurement.radius}%`,
        'width': design.forNode(currentNodeId, 'width'),
        'height': design.forNode(currentNodeId, 'height'),
        'z-index': nodeZIndex
    });

    // update title styles
    const currentNodeTitle = currentNode.find('.title');

    // position the current node title
    const currentTitlePosition = design.forNode(currentNodeId, 'titlePosition');
    currentNodeTitle.removeClass('top middle bottom left center right');
    if(currentTitlePosition === 'top-left') {
        currentNodeTitle.addClass('top left');
    } else if(currentTitlePosition === 'top-center') {
        currentNodeTitle.addClass('top center');
    } else if(currentTitlePosition === 'top-right') {
        currentNodeTitle.addClass('top right');
    } else if(currentTitlePosition === 'left') {
        currentNodeTitle.addClass('middle left');
    } else if(currentTitlePosition === 'right') {
        currentNodeTitle.addClass('middle right');
    } else if(currentTitlePosition === 'bottom-left') {
        currentNodeTitle.addClass('bottom left');
    } else if(currentTitlePosition === 'bottom-center') {
        currentNodeTitle.addClass('bottom center');
    } else if(currentTitlePosition === 'bottom-right') {
        currentNodeTitle.addClass('bottom right');
    } else {
        currentNodeTitle.addClass('middle center');
    }

    // hide-on-level-X
    const hideNodeList = getHideNodeList(currentNodeId);
    const editedClass = currentNode.hasClass('edited') ? 'edited' : '';

    // regular editor use
    if(type === 'regular') {
        currentNode.removeClass().addClass(`selected ${hideNodeList} ${editedClass}`);

    // initial node load
    } else if(type === 'init') {
        currentNode.removeClass().addClass(`${hideNodeList} ${editedClass}`);

    }
    
    log('updateNodeDataToDom:done' + currentNodeId);
}

function updateAllNodesFont() {
    $.each(allCurrentDomNodes, (nodeId) => {
        updateNodeFontToDom(allCurrentDomNodes[nodeId]);
        updateNodeFontToStore(nodeId);
    });
}

function updateNodeFontToDom(node) {
    node.css({
        'font-family': store.get().map.fonts.nodeContent
    });
}

function updateNodeFontToStore(nodeId) {
    store.get().nodes[nodeId].design.set({
        fontFamily: store.get().map.fonts.nodeContent
    });
}

// COPY NODE
// ---------------------------------------------------------------
function copy(currentNodeId, type) {
    copyNodeToStore(currentNodeId);
    copyNodeToDom(type);
}

function copyNodeToDom(type) {
    // const copiedNodeId = nodeId - 1;
    const copiedNodeId = nodeId;
    const x = store.get().nodes[copiedNodeId].position.x;
    const y = store.get().nodes[copiedNodeId].position.y;

    // add copied node to dom
    addNodeToDom(x, y, copiedNodeId);

    // select new added node and update styles
    const currentNode = $(`node[data-id=${copiedNodeId}]`);
    updateNodeDataToDom(currentNode, copiedNodeId);

    // select copied node
    removeClassSelected();
    if (!type || type !== 'regular'){
        currentNode.addClass('selected');
    }
    $(document).trigger('nodeClickedEvent', [currentNode]);
}

function copyNodeToStore(currentNodeId) {
    const $node = $('node');
    const newNodeId = parseInt($node.eq($node.length - 1).data('id')) + 1;
    nodeId = newNodeId;
    // const newNodeId = nodeId++;
    log('Last node ID:')
    log($node.eq($node.length - 1).data('id'));
    log('Copied node id is:')
    log(newNodeId);
    log('Current node is :' + currentNodeId);

    // get current selected node data from store
    const currentNodeFromStore = store.get().nodes[currentNodeId];

    // copy node data object
    const copiedNode = Object.assign({}, currentNodeFromStore);

    // add copied node data to store
    store.get().nodes.set({
        [newNodeId]: copiedNode
    });

    // update copied node data to store
    store.get().nodes[newNodeId].set({
        position: {
            x: currentNodeFromStore.position.x + 15,
            y: currentNodeFromStore.position.y + 15
        },
        navigation: {
            previousId: -1,
            nextId: -1
        }
    });

    // update map level control
    $(document).trigger('updateMapLevelControlEvent', ['node-copied', newNodeId]);

    log('--- node.js ---');
    log('copy node to store');
    log(store.get().nodes[newNodeId]);
    log('---------------');
}




// ---------------------------------------------------------------
// UTIL
// ---------------------------------------------------------------
function removeClassSelected() {
    $('node').removeClass('selected');
}

function removeClassDrawSelected() {
    $('node').removeClass('draw-selected');
}

function clearDrawingStates() {
    isDrawingEdge = false;
}

function isDevelopment() {
    return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
}

function getHideNodeList(currentNodeId) {
    // hide-on-level-X
    let hideNodeList = '';

    for(let i=1; i < store.get().nodes[currentNodeId].visibility.minLevel; i++) {
        hideNodeList += `hide-on-level-${i} `;
    }

    for(let i=store.get().nodes[currentNodeId].visibility.maxLevel + 1; i <= store.get().map.visibilityLevels; i++) {
        hideNodeList += `hide-on-level-${i} `;
    }

    return hideNodeList;
}

function updateAllNodesMaxVisibilityLevel() {
    const newMaxVisibilityLevel = store.get().map.visibilityLevels;

    if (newMaxVisibilityLevel < oldMaxVisibilityLevel) {
        Object.values(store.get().nodes).forEach((node) => {
            node.visibility.transact();
            if (node.visibility.minLevel > newMaxVisibilityLevel) {
                node.visibility.set('minLevel', newMaxVisibilityLevel);
            }
            if (node.visibility.maxLevel > newMaxVisibilityLevel) {
                node.visibility.set('maxLevel', newMaxVisibilityLevel);
            }
            node.visibility.run();
        });
    } else if (newMaxVisibilityLevel > oldMaxVisibilityLevel) {
        Object.values(store.get().nodes).forEach((node) => {
            if (node.visibility.maxLevel === oldMaxVisibilityLevel) {
                node.visibility.set('maxLevel', newMaxVisibilityLevel);
            }
        });
    }

    oldMaxVisibilityLevel = newMaxVisibilityLevel;
}

function updateAllNodesVisibilityLevel() {
    Object.keys(store.get().nodes).forEach((id) => {
        // hide-on-level-X
        const currentNode = $(`node[data-id=${id}]`);
        const hideNodeList = getHideNodeList(id);
        currentNode.removeClass().addClass(hideNodeList);
    });
}

function getNodeZIndex(currentNodeId) {
    const nodeZIndex = store.get().map.visibilityLevels - store.get().nodes[currentNodeId].visibility.minLevel;
    return nodeZIndex;
}
